import { ActionIcon } from "PFComponents/action_icon";
import TooltipIcon from "PFComponents/tooltip_icon/tooltip_icon";
import React from "react";
import { useTranslation } from "react-i18next";

type ShowAllBookingsIconProps = {
  isEnabled: boolean;
  onToggle: (value: boolean) => void;
  className?: string;
};

export const ShowAllBookingsIcon = ({
  isEnabled,
  onToggle,
  className
}: ShowAllBookingsIconProps): JSX.Element => {
  const { t } = useTranslation("bookingModule");

  return (
    <TooltipIcon
      className={className}
      content={t(isEnabled ? "projects.hideAllBookingsTooltip" : "projects.showAllBookingsTooltip")}
      IconComponent={() => (
        <ActionIcon name={isEnabled ? "shown" : "hidden"} onClick={() => onToggle(!isEnabled)} />
      )}
    />
  );
};
